// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProviderAddressInfoDto } from './IProviderAddressInfoDto';
import {
    IProviderAddressInfoDtoFromJSON,
    IProviderAddressInfoDtoFromJSONTyped,
    IProviderAddressInfoDtoToJSON,
    IProviderAddressInfoDtoToJSONTyped,
} from './IProviderAddressInfoDto';

/**
 * 
 * @export
 * @interface ICreateProviderAggregatorDto
 */
export interface ICreateProviderAggregatorDto {
    /**
     * 
     * @type {string}
     * @memberof ICreateProviderAggregatorDto
     */
    facility_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateProviderAggregatorDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateProviderAggregatorDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateProviderAggregatorDto
     */
    tax_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ICreateProviderAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {Array<IProviderAddressInfoDto>}
     * @memberof ICreateProviderAggregatorDto
     */
    addresses?: Array<IProviderAddressInfoDto>;
}

/**
 * Check if a given object implements the ICreateProviderAggregatorDto interface.
 */
export function instanceOfICreateProviderAggregatorDto(value: object): value is ICreateProviderAggregatorDto {
    return true;
}

export function ICreateProviderAggregatorDtoFromJSON(json: any): ICreateProviderAggregatorDto {
    return ICreateProviderAggregatorDtoFromJSONTyped(json, false);
}

export function ICreateProviderAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateProviderAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_name': json['facility_name'] == null ? undefined : json['facility_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(IProviderAddressInfoDtoFromJSON)),
    };
}

export function ICreateProviderAggregatorDtoToJSON(json: any): ICreateProviderAggregatorDto {
    return ICreateProviderAggregatorDtoToJSONTyped(json, false);
}

export function ICreateProviderAggregatorDtoToJSONTyped(value?: ICreateProviderAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_name': value['facility_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'tax_id': value['tax_id'],
        'employee_id': value['employee_id'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(IProviderAddressInfoDtoToJSON)),
    };
}

